import { Session } from '@/lib/auth/auth-helper'
import { cleanAccessToken, isRefreshResponseValid } from '@/lib/auth/refresh'
import { ModulusAPIResponse } from '@unx/shared/api/external-api'
import { getIsResponseIpMismatch } from '@unx/shared/api/utils'
import { AuthResponse } from '@unx/shared/types/login'
import { buildIpMismatchRedirectPath } from './utils'

export type RefreshResult =
  | { success: true; session: Session }
  | { success: false; redirectPath?: string }

/**
 * Handles refresh token response validation and extraction
 * Returns the result with either a new session or redirect path for logout
 */
export const handleRefreshTokenResponse = (
  data: ModulusAPIResponse<AuthResponse>,
  userId?: string,
): RefreshResult => {
  // Validate refresh response
  const accessToken = data.data?.access_token
  if (isRefreshResponseValid(data) && userId && accessToken) {
    // Extract and clean access token
    const newAccessToken = cleanAccessToken(accessToken)
    const refreshSession: Session = {
      accessToken: newAccessToken,
      id: userId,
    }
    return { success: true, session: refreshSession }
  }

  // Check if the failure is due to IP mismatch
  const isIpMismatch = getIsResponseIpMismatch(data)
  if (isIpMismatch) {
    return { success: false, redirectPath: buildIpMismatchRedirectPath() }
  }

  // Generic failure
  return { success: false }
}
